<template lang="pug">
.accordion(:class="{ 'is-open': expand }")
  .accordion-ttl(@click="toggle()")
    slot(name="title")
  .accordion-body
    slot(name="body")
</template>

<script>
export default {
  data() {
    return {
      expand: false
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand
    }
  }
}
</script>
